// @flow
import { useState, useEffect } from 'react';

type QueriesType<T: *> = { [string]: T };

export default function useMediaQuery<T: *>(
  /**
   * a list of media queries, assumed to be min-width if not specified.
   * Supported key values are; `default`, `12`, `12px` and variations on css media value.
   * Media value should look like; `min-width: 12px` and be min|max and width|height
   */
  queries: QueriesType<T>,
  onResize?: () => void
): T {
  const { default: defaultValue, ...mediaQueries } = queries;
  if (typeof window === 'undefined') return defaultValue;
  const getMatch = () => {
    const matchedQuery = Object.keys(mediaQueries).find(
      (query) => window.matchMedia(query).matches
    );
    if (!matchedQuery) return defaultValue;
    return mediaQueries[matchedQuery];
  };
  const [value, setValue] = useState(getMatch);
  useEffect(() => {
    function handler() {
      setValue(getMatch);
      if (onResize) onResize();
    }
    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, []);
  return value;
}
